import '@/assets/css/global.css'
import 'ant-design-vue/dist/antd.css'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Antd from 'ant-design-vue'
import language from './language'
import './service/http.js'

Vue.config.productionTip = false
Vue.use(Antd)

Vue.prototype.$EventBus = new Vue()

router.beforeEach((to, from, next) => {
  // 设置页面title
  document.title = language.website
  // 设置导航高亮
  store.commit('updateMenu', to.meta.key)
  if (to.meta.requireAuth === true) {
    if (!sessionStorage.getItem('token')) {
      next({ path: '/login' })
    } else {
      next()
    }
  } else {
    next()
  }
})

new Vue({
  router,
  store,
  data: {
    language: language,
    isEnglish: localStorage.getItem('jw-locale') === 'en-US',
    isMobile: /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)
  },
  render: h => h(App)
}).$mount('#app')
